// tslint:disable: variable-name
// special variable-name for the consistent with the server side data.
export class TokenLog {
  access_token: string;
  token_type: string;
  refresh_token: string;
  expires_in: number;
  scope: string;
  domainId: string;
  working_domain: string;
  locale: string;
  jti: string;
  userId: string;
  userLoginId: string;
  currentUserName: string;
  email: string;
  newuiTimeZoneCode: string;
  dateFormatCode: string;
  dateTimeFormatCode: string;
  userPriv: string;

  constructor(tokenLog: Partial<TokenLog> = {}) {
    const {
      access_token = null,
      token_type = null,
      refresh_token = null,
      expires_in = null,
      scope = null,
      domainId = null,
      working_domain = null,
      locale = null,
      jti = null,
      userId = null,
      userLoginId = null,
      currentUserName = null,
      email = null,
      newuiTimeZoneCode = null,
      dateFormatCode = null,
      dateTimeFormatCode = null,
      userPriv = null
    } = tokenLog;
    this.access_token = access_token;
    this.token_type = token_type;
    this.refresh_token = refresh_token;
    this.expires_in = expires_in;
    this.scope = scope;
    this.domainId = domainId;
    this.working_domain = working_domain;
    this.locale = locale;
    this.jti = jti;
    this.userId = userId;
    this.userLoginId = userLoginId;
    this.currentUserName = currentUserName;
    this.email = email;
    this.newuiTimeZoneCode = newuiTimeZoneCode;
    this.dateFormatCode = dateFormatCode;
    this.dateTimeFormatCode = dateTimeFormatCode;
    this.userPriv = userPriv;
  }
}
